import moment from 'moment';

export const militaryToNot = time => {
  const today = moment();
  const split = time.split(':');
  if (!split.length > 1) {
    return time;
  }
  today.hour(split[0]).minute(split[1]);
  return today.format('hh:mm a');
};

export const addTime = (date, time) => {
  const day = moment.utc(date);
  if (!time) return day;
  const split = time.split(':');
  if (!split.length > 1) {
    return time;
  }
  day.hour(split[0]).minute(split[1]);
  return day;
};



// WEBPACK FOOTER //
// ./src/helpers/timeFormatHelpers.js